import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const radioCardDefaultVariants = {
  "size": "md"
}
const radioCardCompoundVariants = []

const radioCardSlotNames = [
  [
    "root",
    "radioCard__root"
  ],
  [
    "label",
    "radioCard__label"
  ],
  [
    "description",
    "radioCard__description"
  ]
]
const radioCardSlotFns = /* @__PURE__ */ radioCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, radioCardDefaultVariants, getSlotCompoundVariant(radioCardCompoundVariants, slotName))])

const radioCardFn = memo((props = {}) => {
  return Object.fromEntries(radioCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const radioCardVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...radioCardDefaultVariants, ...compact(variants) })

export const radioCard = /* @__PURE__ */ Object.assign(radioCardFn, {
  __recipe__: false,
  __name__: 'radioCard',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: radioCardVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, radioCardVariantKeys)
  },
  getVariantProps
})